import { IoClose, IoCopy } from "react-icons/io5";
import { FaWhatsapp, FaQrcode } from "react-icons/fa";
import { toast } from "react-toastify";
import { useState } from "react";
import { handleCopy } from "../helpers";

const PaymentLinkModal = ({ isOpen, onClose, paymentData }) => {
  const [showQR, setShowQR] = useState(false);
  if (!isOpen) return null;

  const qrImageSrc = 'data:image/png;base64,' + paymentData?.qrCodeUrl;

  const copyLink = () => {
    // navigator.clipboard.writeText(paymentData?.paymentLink);
    // toast.success("Payment link copied!");
    handleCopy(paymentData?.paymentLink);
  };

  const whatsappLink = `https://wa.me/+91${paymentData?.mobile}?text=${encodeURIComponent(
    paymentData?.reminderText
  )}`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md relative animate-fadeIn">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute right-3 top-3 text-gray-500 hover:text-gray-700"
        >
          <IoClose size={22} />
        </button>

        <div className="p-6">
          <h2 className="text-xl font-semibold text-gray-900">
            Payment Link
          </h2>

          <p className="text-gray-600 text-sm mt-1">
            You can copy the link, send on WhatsApp, or show QR code.
          </p>

          {/* Link Display */}
          <div className="mt-4 border rounded-lg px-3 py-2 bg-gray-50 flex items-center justify-between gap-3">
            <p className="text-gray-700 text-sm truncate">{paymentData?.paymentLink}</p>
            <button
              onClick={copyLink}
              className="p-2 rounded-lg bg-gray-200 hover:bg-gray-300"
            >
              <IoCopy size={18} className="text-gray-700" />
            </button>
          </div>

          {/* QR Code from backend */}
          {showQR && paymentData?.qrCodeUrl && (
            <div className="mt-4 flex flex-col items-center">
              <img
                src={qrImageSrc}
                alt="QR Code"
                className="w-44 h-44 object-contain border p-2 rounded-lg shadow-sm bg-white"
              />
              <p className="text-gray-500 text-xs mt-2">Scan to Pay</p>
            </div>
          )}

          {/* Action Buttons */}
          <div className="mt-6 flex flex-col gap-3">
            <button
              onClick={copyLink}
              className="py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 transition w-full"
            >
              Copy Link
            </button>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="py-2 rounded-lg bg-green-600 text-white text-sm font-semibold flex items-center justify-center gap-2 hover:bg-green-700 transition w-full"
            >
              <FaWhatsapp size={16} />
              Share on WhatsApp
            </a>

            {/* Toggle QR Code Button */}
            {paymentData?.qrCodeUrl &&
              <button
                onClick={() => setShowQR(!showQR)}
                className="py-2 rounded-lg bg-gray-200 text-gray-800 text-sm font-semibold flex items-center justify-center gap-2 hover:bg-gray-300 transition w-full"
              >
                <FaQrcode size={16} />
                {showQR ? "Hide QR Code" : "Show QR Code"}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentLinkModal;
